import React, { Component } from 'react';
import { connect } from 'react-redux'
import { changePage, getItemList, defaultStoreItemList, selectedFood, setTotalOrderPrice } from '../../../../action/hcommerce'
import { closeOrderPopUp } from '../../../action/hCommerce2'
import { popupOpenClose, setConformPage } from '../../../../action/action'
import { contScrollToBottom, hideScrolltoBottomHandler} from '../../../JS/scroll';
import { CMSPath } from '../../../../config/constant'
import {withTranslation} from "react-i18next";
import { sendAnalytics } from '../../../../action/homeAction';
import { getCleanUrl, getDefaultAnalyticsLabel } from '../../../JS/utility';

class AddOnPopupWithoutGrouping extends Component{

    constructor(props, context) {
        super(props, context);
        this.state = {
            hideBottomArrow: false,
            addOnLength: 0
        }
    }
    

    sortAddOnHandler = (addOns) => {

        let sortedArr=[];

        if(!addOns || addOns.length === 0){
            return;
        }

        sortedArr = [...addOns]
        sortedArr.sort((a,b)=> a.priority > b.priority ? 1 : -1)
        return sortedArr;
    }

    addOnCheckBoxCLickFunction = (addOnItem) => {
        let existingAddOn = false
        let addOnCopy = [...this.props.addOn]
        
        if (this.props.addOn.length === 0) {
            addOnCopy.push({...addOnItem, quantity: 1});
        } else {
            this.props.addOn.map((iterator, index) => {
                if (iterator.id == addOnItem.id) {
                    addOnCopy.splice(index, 1);
                    existingAddOn = true
                }
            })

            if (!existingAddOn) {
                addOnCopy.push({...addOnItem, quantity: 1});
            }
        }
        this.props.addOnCheckBoxCLick(addOnCopy, () => {console.log("Selected addon list:"); console.log(this.props.addOn)})
    }

    componentDidMount(){
        let count = 0
        for(let i=0;i<this.props.itemAddOnsInfo.length;i++){
            if(this.props.SelectedFood.id == this.props.itemAddOnsInfo[i].storeItemId) count++
        }
        this.setState({addOnLength: count })
    }

    render(){

        let selectedAddOn = false;
        const { t } = this.props
        return(
            <section class="overlay">
                <div class="overlay-window-container">
                    <div class="overlay-window">
                        <div onScroll={() => hideScrolltoBottomHandler('addOnPopup', (bool) => this.setState({ hideBottomArrow: bool }))} id="addOnPopup" class="overlay-content padding-0" style = {{height:"60vh",overflowY:"scroll"}}>
                            <div class="overlay-header" style = {{position:"sticky",top:"0",backgroundColor:"#fff",zIndex:"5"}}>
                                <div class="overlay-header-title">
                                    <h2>{t('hcommerce.addon_popup.header')}</h2>
                                </div>
                                {/* <a onClick={this.props.backBtn} class="close" style={{
                                    backgroundColor: this.props.menuColor.assetBackgroundSelectorColor
                                }}><i class="fa fa-times"></i></a> */}
                            </div>
                            {/* <div class="overlay-header-body" >
                                <div class="overlay-tile">
                                    <label for="option1">
                                        <div class="overlay-tile-img" ></div>
                                        <div class="overlay-tile-text">
                                            <p><strong>No selection</strong></p>
                                        </div>
                                        <div class="overlay-tile-input" >
                                            <input type="radio"
                                            onClick = {() => this.setState(prev => ({noSelection: !prev.noSelection}))} 
                                            disabled = {this.state.addOn.length > 0}
                                            checked = {this.state.noSelection}/>
                                        </div>
                                    </label>

                                </div>
                            </div> */}
                            {
                                this.sortAddOnHandler(this.props.itemAddOnsInfo).map((iterator,index) => {
                                
                                    let imagePathAddOns = null;
                                    imagePathAddOns = encodeURI(getCleanUrl(`${iterator.largeImage}`))
                                
                                    return this.props.SelectedFood.id == iterator.storeItemId && (<div class="overlay-header-body" key = {index} >
                                            <div class="overlay-tile">
                                                <label htmlFor="option1">
                                                    <div class="overlay-tile-img" 
                                                    style={{
                                                        background: `url('${imagePathAddOns}') center center no-repeat`,
                                                        backgroundSize: "cover"
                                                    }}></div>
                                                    <div class="overlay-tile-text">
                                                        <p><strong dangerouslySetInnerHTML={{__html: `${iterator.name}`}}></strong></p>
                                                        <p dangerouslySetInnerHTML={{__html: `${this.props.currencyCode} ${iterator.price}`}}></p>
                                                    </div>
                                                    {
                                                        this.props.addOn.map((iter,index) => {
                                                            if (iter.id === iterator.id) {
                                                                selectedAddOn = true
                                                                return (<div class="overlay-tile-input" >
                                                                <input type="checkbox" checked = {true} 
                                                                onClick = {() => this.addOnCheckBoxCLickFunction(iterator)}
                                                                // disabled = {this.state.noSelection}
                                                                />
                                                            </div>
                                                            )}
                                                        })
                                                    }
                                                    {
                                                        !selectedAddOn && !this.props.storeInfo.disableAddRemoveItemsButtons ? <div class="overlay-tile-input">
                                                        <input type="checkbox" checked = {false} 
                                                        onClick = {() => this.addOnCheckBoxCLickFunction(iterator)}
                                                        // disabled = {this.state.noSelection}
                                                        />
                                                        </div> : selectedAddOn = false
                                                    }
                                                </label>
                                            </div>
                                            
                                        </div>
                                    )
                                })
                            }
                        </div>
                        { this.state.addOnLength > 5 && !this.state.hideBottomArrow &&
                            <div class="doorkey" onClick = {() => contScrollToBottom("addOnPopup")}>
                                <a style={{backgroundColor: this.props.menuColor.assetBackgroundSelectorColor}} class="tile-container"><i class="fas fa-chevron-down"></i></a>
                            </div>
                        }
                        <div class="overlay-controls">
                            { !this.props.storeInfo.disableAddRemoveItemsButtons && <button class="button w-100" 
                            onClick = {() => {this.props.addToMyOrder();}} 
                            disabled = {this.props.addOn.length === 0 /*&& !this.state.noSelection*/}>{t('hcommerce.addon_popup.add_to_myorder')}</button>}
                            <button class="button w-100 margin-top-1 secondary" onClick={this.props.backBtn}>{t('hcommerce.addon_popup.close')}</button>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        SelectedFood: state.store.Hcommerce.SelectedFood,
        SelectedNavComponent: state.store.Hcommerce.SelectedNavComponent,
        upsellItem: state.store.Hcommerce.upsellItem,
        myOrders: state.store.Hcommerce.myOrders,
        storeInfo: state.store.Hcommerce.storeInfo,
        menuColor: state.store.home.MenuColor,
        itemAddOnsInfo: state.store.Hcommerce.itemAddOnsInfo,
        currencyCode: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.code : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgets: state.store.sideNavBar.currentWidget,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
    }
}

export default connect(mapStateToProps,{
    changePage,
    popupOpenClose,
    setConformPage,
    selectedFood,
    setTotalOrderPrice,
    closeOrderPopUp,
    sendAnalytics
})(withTranslation('translations')(AddOnPopupWithoutGrouping));